import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../App.css"
import Navbar from '../components/Navbar'
import SecondaryHero from "../components/SecondaryHero";
import Footer from '../components/Footer'
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";



// import "../App.css"

const Careers = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <>

      {/* ✅ TAB TITLE + SEO */}
      <Helmet>
        <title>Careers | VisionBird Technologies</title>
        <meta
          name="description"
          content="Explore career opportunities at VisionBird Technologies. Join our creative and technical team and grow your career with us."
        />
        <meta
          name="keywords"
          content="VisionBird careers, jobs in Pakistan, software house jobs, UI UX designer jobs, developer jobs"
        />
      </Helmet>

        <Navbar/>
      <SecondaryHero
        title="Join "
        titleLast=""
        highlight="Our Team"
        description=" At VisionBird Technologies, we believe that great companies are built by great people. 
        As a growing software house and creative digital agency, we are always looking for 
        passionate, skilled, and innovative individuals who want to build meaningful digital 
        experiences and shape the future of technology."
        image="/assets/Images/Resume-pana 1.png"
      />
     <div className="careers-section padding-container">
      <div className="page-wrapper">
        <div className="careers-content">

          {/* Introduction */}
          <div className="careers-intro" data-aos="fade-up" data-aos-duration="1000">
            <h1> <span className="orange-text">Our Culture</span></h1>
            <p>
             
            </p>
            <p>
              Our culture is built on creativity, collaboration, learning, and responsibility. 
              Whether you're a designer, developer, strategist, marketer, or animator, VisionBird 
              Technologies offers a workplace where your talent is recognized, your ideas matter, 
              and your growth is a priority.
            </p>
          </div>

          {/* Why Work With Us */}
          <div className="careers-why" data-aos="fade-up" data-aos-duration="1000">
            <h1>Why Work With <span className="orange-text">Us?</span></h1>
            
            <div className="why-point">
              <h2>A Culture of Learning & Growth</h2>
              <p>
                We invest in people. From training sessions and design/development workshops to 
                participation in real-world client projects, we ensure every team member progresses 
                steadily in their career. You will work with experienced designers, developers, 
                and digital strategists who help you refine your craft and grow professionally.
              </p>
            </div>

            <div className="why-point">
              <h2>Opportunities Across Multiple Departments</h2>
              <p>
                As a multi-disciplinary company, we offer diverse roles ranging from technical 
                development to digital creativity. Whether your interest lies in code, design, 
                or digital marketing, we have a pathway for your career.
              </p>
            </div>

            <div className="why-point">
              <h2>Work on Global Projects</h2>
              <p>
                VisionBird Technologies works with clients worldwide from various industries. 
                You'll get the opportunity to work on real international projects, giving you 
                valuable experience across different technologies and design practices.
              </p>
            </div>

            <div className="why-point">
              <h2>Professional, Respectful & Structured Environment</h2>
              <p>
                We follow a corporate structure that maintains professionalism, discipline, and 
                teamwork. Every department operates with clear responsibilities, timelines, and 
                performance standards that help you build strong professional skills.
              </p>
            </div>

            <div className="why-point">
              <h2>Modern Workspace & Tools</h2>
              <p>
                We operate with modern software, updated technologies, high-end systems, and 
                premium tools to ensure that our employees work efficiently without limitations.
              </p>
            </div>
          </div>

          {/* Departments & Career Paths */}
          <div className="careers-departments" data-aos="fade-up" data-aos-duration="1000">
            <h1>Departments & <span className="orange-text">Career Paths</span></h1>
            <p>
              Below are the primary areas in which we frequently hire talented individuals:
            </p>

            {/* Graphic Design & Branding */}
            <div className="department-section">
              <h2>1. Graphic Design & Branding</h2>
              
              <div className="job-role">
                <h3 className="orange-text">Graphic Designer</h3>
                <p><strong>Job Purpose:</strong> Create high-quality graphics for branding, marketing, and social media campaigns.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Design social media posts, banners, campaign visuals</li>
                  <li>Create marketing materials, print assets, and brand identities</li>
                  <li>Collaborate with marketing and multimedia teams</li>
                  <li>Maintain quality, consistency, and brand guidelines</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Proficiency in Photoshop, Illustrator</li>
                  <li>Strong portfolio of design work</li>
                  <li>Understanding of layout, color theory & typography</li>
                </ul>

                <h4>Preferred Skills:</h4>
                <ul>
                  <li>Experience with mockups, brand kits, and corporate templates</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">Branding Specialist</h3>
                <p><strong>Job Purpose:</strong> Develop brand identities and maintain visual consistency across all platforms.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Create logos, brand guidelines, and identity systems</li>
                  <li>Research competitor brands and market trends</li>
                  <li>Ensure brand elements remain consistent on all channels</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Strong conceptual design abilities</li>
                  <li>Ability to craft unified brand visuals</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">High-Resolution Image Specialist / Photo Retoucher</h3>
                <p><strong>Job Purpose:</strong> Enhance, manipulate, and upscale product images for marketing & e-commerce.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Convert low-quality images into high-resolution outputs</li>
                  <li>Clean, color-correct, and retouch photos</li>
                  <li>Provide design assets to both Marketing & Multimedia teams</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Expertise in Photoshop (retouching, masking, enhancements)</li>
                </ul>
              </div>
            </div>

            {/* UI/UX Design Department */}
            <div className="department-section">
              <h2>2. UI/UX Design Department</h2>
              
              <div className="job-role">
                <h3 className="orange-text">UI/UX Designer</h3>
                <p><strong>Job Purpose:</strong> Design user-friendly web and mobile interfaces with a strong focus on user experience.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Create wireframes, prototypes, and UI layouts</li>
                  <li>Conduct UX research and user flow planning</li>
                  <li>Collaborate with developers to ensure accurate implementation</li>
                  <li>Maintain consistency across platforms</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Figma or Adobe XD expertise</li>
                  <li>Strong understanding of UX principles</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">Product Designer</h3>
                <p><strong>Job Purpose:</strong> Design seamless digital product experiences end-to-end.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Research user needs and product requirements</li>
                  <li>Design interface systems, prototypes, and user flows</li>
                  <li>Work with developers to ensure efficient design handoff</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Strong portfolio showing product thinking</li>
                </ul>
              </div>
            </div>

            {/* Full-Stack Development */}
            <div className="department-section">
              <h2>3. Full-Stack Development</h2>
              
              <div className="job-role">
                <h3 className="orange-text">Full-Stack Developer</h3>
                <p><strong>Job Purpose:</strong> Develop complete web applications from UI to backend and database.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Build and maintain full-stack systems</li>
                  <li>Create APIs, databases, and dashboards</li>
                  <li>Integrate front-end and back-end components</li>
                  <li>Troubleshoot, test, and improve performance</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Strong grip on JavaScript/TypeScript</li>
                  <li>Experience with Node.js, Express, React, SQL/NoSQL</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">Backend Developer</h3>
                <p><strong>Job Purpose:</strong> Focus on server-side logic, APIs, security, and databases.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Develop backend architecture</li>
                  <li>Database design & maintenance</li>
                  <li>Build robust and secure APIs</li>
                  <li>Collaborate with developers & DevOps teams</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Node.js / PHP / Python / Java expertise</li>
                  <li>REST API experience</li>
                </ul>
              </div>
            </div>

            {/* SEO & Digital Marketing */}
            <div className="department-section">
              <h2>4. SEO & Digital Marketing</h2>
              
              <div className="job-role">
                <h3 className="orange-text">SEO Specialist</h3>
                <p><strong>Job Purpose:</strong> Improve website ranking, traffic, and online visibility.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Keyword research & competitor analysis</li>
                  <li>On-page, off-page, and technical SEO</li>
                  <li>Conduct SEO audits and implement fixes</li>
                  <li>Track performance with analytics tools</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Knowledge of Google Search Console, Ahrefs, SEMrush</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">Digital Marketing Executive</h3>
                <p><strong>Job Purpose:</strong> Execute marketing campaigns and grow audience engagement.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Social media strategy & content planning</li>
                  <li>Email marketing, ads management, and analytics</li>
                  <li>Coordinate with designers for marketing visuals</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Understanding of digital trends & paid campaigns</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">Social Media Manager</h3>
                <p><strong>Job Purpose:</strong> Manage company and client social media presence.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Create content calendars</li>
                  <li>Publish posts, run campaigns, and engage audience</li>
                  <li>Monitor analytics and optimize content</li>
                </ul>
              </div>
            </div>

            {/* Motion Graphics & Animation */}
            <div className="department-section">
              <h2>5. Motion Graphics & Animation</h2>
              
              <div className="job-role">
                <h3 className="orange-text">Motion Graphics Designer</h3>
                <p><strong>Job Purpose:</strong> Create animations, explainers, product demos, and motion visuals.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Produce animated videos, reels, and explainer clips</li>
                  <li>Collaborate with marketing teams</li>
                  <li>Edit, color grade, and finalize video assets</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>After Effects, Premiere, or DaVinci Resolve skills</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">Video Editor</h3>
                <p><strong>Job Purpose:</strong> Edit high-quality videos for marketing and corporate use.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Assemble raw footage</li>
                  <li>Add effects, transitions, audio, and color correction</li>
                </ul>
              </div>
            </div>

            {/* Web Design & Front-end Development */}
            <div className="department-section">
              <h2>6. Web Design & Front-end Development</h2>
              
              <div className="job-role">
                <h3 className="orange-text">Web Designer</h3>
                <p><strong>Job Purpose:</strong> Create visually engaging web layouts and landing pages.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Convert concepts into responsive web designs</li>
                  <li>Design website sections, banners, and UI components</li>
                  <li>Work closely with front-end developers</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>HTML/CSS familiarity</li>
                  <li>Figma or design tool expertise</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">Front-end Developer</h3>
                <p><strong>Job Purpose:</strong> Build responsive, fast, high-quality web interfaces.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Convert UI designs into pixel-perfect front-end code</li>
                  <li>Develop using HTML, CSS, JS, and modern frameworks</li>
                  <li>Optimize websites for speed and SEO</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Experience in React/Vue/Next.js</li>
                  <li>Understanding of APIs and responsive design</li>
                </ul>
              </div>
            </div>

            {/* Mobile App Development */}
            <div className="department-section">
              <h2>7. Mobile App Development</h2>
              
              <div className="job-role">
                <h3 className="orange-text">Flutter Developer / React Native Developer</h3>
                <p><strong>Job Purpose:</strong> Design and develop high-quality cross-platform mobile applications.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Build mobile apps for iOS & Android</li>
                  <li>Integrate APIs, push notifications, and third-party services</li>
                  <li>Optimize app performance and UI consistency</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Experience in Flutter or React Native</li>
                  <li>Understanding of mobile UI/UX</li>
                </ul>
              </div>

              <div className="job-role">
                <h3 className="orange-text">Android Developer</h3>
                <p><strong>Job Purpose:</strong> Develop and maintain native Android apps.</p>
                
                <h4>Key Responsibilities:</h4>
                <ul>
                  <li>Build features using Kotlin/Java</li>
                  <li>Work on performance, testing, and updates</li>
                </ul>

                <h4>Requirements:</h4>
                <ul>
                  <li>Strong knowledge of Android SDK</li>
                  <li>Experience with Firebase preferred</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Life at VisionBird Technologies */}
          <div className="careers-life" data-aos="fade-up" data-aos-duration="1000">
            <h1>Life at <span className="orange-text">VisionBird Technologies</span></h1>
            <ul>
              <li>Professional and friendly corporate culture</li>
              <li>Growth-oriented environment with mentorship</li>
              <li>Opportunities to work on international projects</li>
              <li>Team-based structure with clear responsibilities</li>
              <li>Regular performance evaluations</li>
              <li>A workplace that respects time, talent, and creativity</li>
            </ul>
          </div>

          {/* Join Our Team */}
          <div className="careers-join" data-aos="fade-up" data-aos-duration="1000">
            <h1>Join Our <span className="orange-text">Team</span></h1>
            <p>
              Whether you are a fresh graduate or an experienced professional, we welcome you to explore opportunities at VisionBird Technologies.
            </p>
            <br />
            
              <Link className="cta-btn drop-cv" to="/ApplyForJob">
                <strong>Send your CV/Portfolio to :  </strong>
             jobs@visionbird.com              </Link>
             <br />
             <br />
        
          </div>

        </div>
      </div>

      <style jsx>{`
        .careers-section {
          padding: 20px 50px 0px 50px;        }
        
        .careers-content {
          max-width: 1400px;
          margin: 0 auto;
        
        }
        
        h1 {
          font-family: 'karantina-bold', sans-serif;
          font-size: 42px;
          margin-bottom: 10px;
       
        }
        
        h2 {
          font-family: 'poppins-bold', sans-serif;
          font-size: 24px;
         
          padding-bottom: 10px;
          border-bottom: 2px solid #ff6b00;
        }
        
        h3 {
          font-family: 'poppins-bold', sans-serif;
          font-size: 20px;
          margin: 20px 0 10px;
          color: #444;
        }
        
        h4 {
          font-family: 'poppins-semibold', sans-serif;
          font-size: 16px;
          margin: 15px 0 8px;
          color: #555;
        }
       
        ul {
          margin-left: 20px;
          margin-bottom: 20px;
        }
        
        li {
          font-family: 'poppins-regular', sans-serif;
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 8px;
          color: #555;
        }
        
        .orange-text {
          color: #ff6b00;
        }
        
        .department-section {
          margin-bottom: 40px;
          padding-bottom: 20px;
          border-bottom: 1px solid #e0e0e0;
        }
        
        .job-role {
          background: #f9f9f9;
          padding: 20px;
          border-radius: 8px;
          margin: 15px 0;
          border-left: 4px solid #ff6b00;
        }
        
        .why-point {
          margin-bottom: 25px;
          padding-bottom: 15px;
          border-bottom: 1px solid #f0f0f0;
        }
        
        .contact-information {
          background: linear-gradient(135deg, #ff6b00, #ff8c00);
          padding: 25px;
          border-radius: 10px;
          text-align: center;
          margin-top: 30px;
          color: white;
        }
        
        .drop-cv{
          background: none;
          text-decoration: underline;
          color: orange;
        }
        .drop-cv:hover{
          transform: scale(1.1) ! important;
          background: none;
          text-decoration: underline;
          color: orange;
        }
        
        @media (max-width: 768px) {
          h1 {
            font-size: 32px;
          }
          
          h2 {
            font-size: 20px;
          }
          
          h3 {
            font-size: 18px;
          }
          
          .job-role {
            padding: 15px;
          }
        }
      `}</style>
    </div>
    <Footer/>
    </>
    
   
  );
};

export default Careers;